import { useMemo } from 'react';

import { LoadingSpinner } from '../../molecules/loading-spinner/loading-spinner';
import { LayoutContext, useLayoutContext } from '../layout-context';

type AppShellProps = {
  readonly header: React.ReactNode;
  readonly children: React.ReactNode;
  readonly isLoading?: boolean;
};

function AppShell({ header, children, isLoading = false }: AppShellProps) {
  const parent = useLayoutContext();
  const value = useMemo(() => ({ ...parent, inShell: true }), [parent]);

  return (
    <LayoutContext.Provider value={value}>
      <div className="flex min-h-dvh flex-col">
        {header}
        <main className="flex min-h-0 flex-1 flex-col">{isLoading ? <LoadingSpinner /> : children}</main>
      </div>
    </LayoutContext.Provider>
  );
}

AppShell.displayName = 'AppShell';

export { AppShell };
export type { AppShellProps };
